import React, { Component } from "react";
import GlobalNavBar from "../shared/globalNavBar/GlobalNavBar";
import PO from "./pure/PO";
import POReporting from "../components/reporting/POReporting";
import Footer from "../shared/Footer/Footer";
import withIdleTimer from "../common/WithIdleTimer";
import { Route, Router } from "react-router-dom";
import { withTranslation } from "react-i18next";
import SearchWrapper from "../components/search/searchWrapper/SearchWrapper";
import OrdersSearch from "../components/search/searchWrapper/orders/OrdersSearch";
import DealerSearch from "../components/search/searchWrapper/dealer/DealerSearch";
import NscSearch from "../components/search/searchWrapper/nsc/NscSearch";

class POApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderApp: false,
      padding: "70px",
    };

    this.user = new PO(this.props.token, this.props.userDetails);
  }

  componentDidMount() {
    this.props.i18n.changeLanguage("en");
    this.setState({ renderApp: true });
  }

  setPadding = (padding) => {
    if (padding > 70) {
      this.setState({ padding: padding + "px" });
    }
  };

  render() {
    return (
      this.state.renderApp && (
        <Router history={this.props.history}>
          <div className="appWrapper" id="appWrapper">
            <div style={{ paddingTop: this.state.padding }}>
              <GlobalNavBar
                {...this.props}
                setPadding={this.setPadding}
                user={this.user}
                urlPath={window.location.pathname}
              />
            </div>
            <Route
              exact
              path="/(|reporting)"
              component={withIdleTimer(() => (
                <POReporting {...this.props} user={this.user} />
              ))}
            />
            <Route
              exact
              path="/search"
              component={withIdleTimer(() => (
                <SearchWrapper {...this.props} user={this.user} />
              ))}
            />
            <Route
              exact
              path="/search/orders"
              component={withIdleTimer(() => (
                <OrdersSearch
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.user}
                />
              ))}
            />
            <Route
              exact
              path="/search/dealer"
              component={withIdleTimer(() => (
                <DealerSearch
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.user}
                  poDealerSearch={true}
                />
              ))}
            />
            <Route
              exact
              path="/search/nsc"
              component={withIdleTimer(() => (
                <NscSearch
                  {...this.props}
                  localizedInfo={this.localizedInfo}
                  user={this.user}
                />
              ))}
            />
            <Footer
              isDealer={false}
              fromNscDealerSearch={this.props.fromNscDealerSearch}
              footerTitle={this.props.t("Footer.title")}
              helpSupportTitle={this.props.t("Footer.help")}
              permissions={this.props.userDetails.permissions}
            />
          </div>
        </Router>
      )
    );
  }
}

export default withTranslation("emp")(POApp);
